import React from 'react';
import { useFormContext } from 'react-hook-form';
import { BeneficiaryType, TrustsDTO } from '../../../../../../api/useTrustsQuery';
import { ScrollableContent } from '../../UpsertTrustModal.styles';
import { BeneficiariesTable } from './components/BeneficiariesTable/BeneficiariesTable';
import { InputMask } from '../../../../../../../../CommonComponents/OPL/Input/InputMask';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { FormValues } from '../../UpsertTrustModal.meta';
import { useBeneficiaries } from './useBeneficiaries';

interface Props {
  data: TrustsDTO;
}

export const Beneficiaries: React.FC<Props> = ({ data }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormValues>();

  const {
    beneficiariesOptions,
    primaryBeneficiariesFieldArray,
    contingentBeneficiariesFieldArray,
  } = useBeneficiaries({ data });

  return (
    <ScrollableContent as="section" display="flex" flexDirection="column">
      <BeneficiariesTable
        beneficiaryType={BeneficiaryType.Primary}
        fieldArray={primaryBeneficiariesFieldArray}
        beneficiariesOptions={beneficiariesOptions}
      />

      <BeneficiariesTable
        beneficiaryType={BeneficiaryType.Contingent}
        fieldArray={contingentBeneficiariesFieldArray}
        beneficiariesOptions={beneficiariesOptions}
      />

      <InputMask
        {...register('lastBeneficiaryUpdate')}
        label="When were these instructions last updated?"
        mask="99/99/9999"
        placeholder="MM/DD/YYYY"
        leftIcon="far fa-calendar-alt"
        formVariant={errors.lastBeneficiaryUpdate ? 'error' : undefined}
        helperText={errors.lastBeneficiaryUpdate?.message}
        css="width: 338px"
        ml="24"
        mt="16"
      />

      <Text fontSize="small" color="neutral.500" px="24" mt="auto" pt="24">
        This is for financial planning informational purposes only. Any information entered here
        will not be updated at your financial institution. To update beneficiary information with
        your financial institution, please contact your advisor.
      </Text>
    </ScrollableContent>
  );
};
